import React, { useState } from 'react';
import {
  Box,
  IconChevronRight16,
  IconFixDelivery16,
  IconNoteAdd16,
  IconShoppingBag16,
  IconFixDelivery24,
  IconNewWindow24,
  IconNoteAdd24,
  IconShoppingBag24,
  Link,
  Modal,
  ModalFooter,
  Stack,
  Text,
  useScreenSize,
} from '@stitch-fix/mode-react';
import { loadTranslations } from '../../../shared/i18n';
import translations from './translations.json';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import {
  trackNewEntryPointsCardClick,
  trackStyleQuizModalCtaClick,
} from '../ProductDetailsPage/ProductDetailsPage.tracking';
import './styles.module.scss';

const { useTranslation } = loadTranslations(translations, 'StyleQuizModal');

const StyleQuizModal = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [state] = useProductDetailsPageContext();
  const isMobileScreensize = useScreenSize() === 'sm';

  const heading = (
    <Text mt={0.5} setting="title-large">
      Take our style quiz and unlock access to:
    </Text>
  );

  const modalLayout = (
    <Stack
      spacing={1.5}
      mt={1.5}
      mb={0.75}
      hAlign={{ sm: 'start', md: 'center' }}
    >
      <Box styleName="section-container">
        <Box styleName="icon">
          {isMobileScreensize ? <IconNoteAdd16 /> : <IconNoteAdd24 />}
        </Box>
        <Box>
          <Text as="h3" setting="title-xsmall">
            {t('stylistText')}
          </Text>
          <Text as="p" setting="body-small">
            {t('stylistSubtext')}
          </Text>
        </Box>
      </Box>
      <Box styleName="section-container">
        <Box styleName="icon">
          {isMobileScreensize ? <IconFixDelivery16 /> : <IconFixDelivery24 />}
        </Box>
        <Box>
          <Text as="h3" setting="title-xsmall">
            {t('shippingText')}
          </Text>
          <Text as="p" setting="body-small">
            {t('shippingSubtext')}
          </Text>
        </Box>
      </Box>
      <Box styleName="section-container">
        <Box styleName="icon">
          {isMobileScreensize ? <IconShoppingBag16 /> : <IconShoppingBag24 />}
        </Box>
        <Box>
          <Text as="h3" setting="title-xsmall">
            {t('shopText')}
          </Text>
          <Text as="p" setting="body-small">
            {t('shopSubtext')}
          </Text>
        </Box>
      </Box>
    </Stack>
  );

  return (
    <Box>
      <Link
        size="tertiary"
        as="button"
        onClick={() => {
          setIsOpen(true);
          trackNewEntryPointsCardClick(state);
        }}
        endIcon={<IconChevronRight16 />}
      >
        Get started
      </Link>

      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        heading={heading}
        hAlign={{ sm: 'left', md: 'center' }}
        variant="inset-small"
        footer={
          <ModalFooter
            primaryAction={{
              text: t('ctaText'),
              endIcon: <IconNewWindow24 />,
              onClick: () => trackStyleQuizModalCtaClick(state),
            }}
            as="a"
            href="/signup"
            target="_blank"
            mt={{ sm: 0.75, md: 1.25 }}
          />
        }
        size="medium"
      >
        {modalLayout}
      </Modal>
    </Box>
  );
};

export default StyleQuizModal;
